import {createSmartAction} from 'redux-smart-actions';

export const getArticlePage = createSmartAction(() => ({
  request: {
    url: '/mco-leclub-api/v1/post/accompagnement',
  },
}));

export const getArticlesByPage = createSmartAction(({page}) => {
  const per_page = 3;
  const offset = (page - 1) * per_page;
  return {
    request: {
      url: `/wp/v2/articles?per_page=${per_page}&offset=${offset}`,
    },
    meta: {requestKey: `/${page}`},
  };
});
